
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RedirectionService from '@/services/redirectionService';
import { toast } from 'sonner';

export const useRedirection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const redirectionService = RedirectionService.getInstance();

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Vérifier s'il y a une redirection pour cette URL
    const redirection = redirectionService.checkRedirection(currentPath);
    
    if (redirection) {
      console.log(`Redirection détectée: ${redirection.from} → ${redirection.to} (${redirection.type})`);
      
      // Effectuer la redirection
      navigate(redirection.to, { replace: true });
      
      // Notifier l'utilisateur si nécessaire (pour le debug)
      if (process.env.NODE_ENV === 'development') {
        toast.info(`Redirection: ${redirection.reason}`, {
          description: `${redirection.from} → ${redirection.to}`,
          duration: 3000
        });
      }
      
      return;
    }

    // Vérifier la canonicalisation
    const canonicalUrl = redirectionService.getCanonical(currentPath);
    if (canonicalUrl !== currentPath) {
      console.log(`Canonicalisation détectée: ${currentPath} → ${canonicalUrl}`);
      
      // Rediriger vers l'URL canonique si elle est différente
      navigate(canonicalUrl, { replace: true });
      
      if (process.env.NODE_ENV === 'development') {
        toast.info('URL canonique utilisée', {
          description: `${currentPath} → ${canonicalUrl}`,
          duration: 3000
        });
      }
    }
  }, [location.pathname, navigate, redirectionService]);

  return {
    redirectionService,
    currentCanonical: redirectionService.getCanonical(location.pathname)
  };
};
